/**
 * Origin type of the lead behind a deal (RF-08).
 *
 * Mirrors `LeadOriginTypeEnum` in `trendmulti-apps/libs/trendmulti-core/src/enum/`
 * — the values cross the wire on `Card.leadOrigin.type` and are sent back as the
 * `originType` filter, so they must stay identical string for string.
 */
export enum LeadOriginTypeEnum {
  PAID_SOCIAL = "PAID_SOCIAL",
  ORGANIC_SOCIAL = "ORGANIC_SOCIAL",
  SEARCH = "SEARCH",
  INBOUND_MESSAGING = "INBOUND_MESSAGING",
  IMPORT = "IMPORT",
  WEBHOOK = "WEBHOOK",
  OTHER = "OTHER",
}
